<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>用户野兽币分布</span>
      </div>

      <el-form ref="queryForm" :model="queryParams" :inline="true">
        <el-form-item label="选择类型" prop="level">
          <el-select v-model.number="queryParams.type" placeholder="请选择">
            <el-option
              v-for="item in typeArr"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="开始日期" prop="startDate">
          <el-date-picker
            v-model="queryParams.startDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="结束日期" prop="endDate">
          <el-date-picker
            v-model="queryParams.endDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
          <el-button v-permisaction="['config:userStatData:export']" icon="el-icon-download" size="mini" @click="exportData(2)">导出</el-button>
        </el-form-item>
      </el-form>

      <el-table
        :data="tableData"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="date"
          label="产出区间"
        />
        <el-table-column
          v-for="(item, index) in num"
          :key="index"
          :prop="String(num)+index"
          :label="item.label"
        >
          <template scope="scope">
            {{ scope.row['num'+item.value] }}
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-card>
      <div slot="header" class="clearfix">
        <span>{{ chartTitle }}</span>
      </div>

      <div ref="chartContainer" style="width: 100%; height: 600px;;margin-bottom: 50px" />
    </el-card>
  </div>
</template>

<script>
import { getUserBeastCoinStat } from '@/api/statistics/user_remain'
import { scientificFormat } from '@/utils'
import echarts from 'echarts'

export default {
  name: 'UserBeastCoin',
  data() {
    return {
      typeArr: [
        { label: '产出', value: 1 },
        { label: '消耗', value: 2 },
        { label: '结余', value: 3 }
      ],
      num: [
        { 'label': '0-10', value: 1 },
        { 'label': '11-50', value: 2 },
        { 'label': '51-100', value: 3 },
        { 'label': '101-200', value: 4 },
        { 'label': '201-500', value: 5 },
        { 'label': '501-1000', value: 6 },
        { 'label': '1000+', value: 7 }
      ],
      tableData: [],
      total: 0,
      queryParams: {
        type: 1,
        startDate: '',
        endDate: ''
      },
      chart: {},
      option: {},
      chartTitle: '分布'
    }
  },
  created() {
    this.getTables()
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    handleQuery() {
      this.queryParams.lang = ''
      if (this.queryParams.startDate === '') {
        this.msgError('请选择开始日期')
        return
      }

      if (this.queryParams.endDate === '') {
        this.msgError('请选择结束日期')
        return
      }

      if (this.queryParams.startDate > this.queryParams.endDate) {
        this.msgError('开始日期不能大于结束日期')
        return
      }
      this.getTables()
    },
    getTables() {
      this.spinLevelData = [{ label: '所有等级', value: -1 }]
      getUserBeastCoinStat(this.queryParams).then(res => {
        if (res.code === 200) {
          if (this.queryParams.lang === '1') {
            window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
            return
          }

          const data = res.data.list[0]
          this.tableData = []
          const numArr = []
          const userArr = []
          const mapTitle = { 1: '产出', 2: '消耗', 3: '结余' }
          let obj = { 'date': mapTitle[this.queryParams.type] }
          this.chartTitle = '分布'
          this.chartTitle = mapTitle[this.queryParams.type] + this.chartTitle
          for (let i = 1; i <= 8; i++) {
            obj[ 'num' + i] = data['spin' + i]
            numArr.push(data['spin' + i])
          }
          this.tableData.push(obj)
          obj = { 'date': '人数' }
          for (let i = 1; i <= 8; i++) {
            obj[ 'num' + i] = data['count' + i]
            userArr.push(data['count' + i])
          }
          const date = []
          for (const i in this.num) {
            date.push(this.num[i].label)
          }
          this.tableData.push(obj)
          this.option.xAxis.data = date
          this.option.legend.data[0] = mapTitle[this.queryParams.type]
          this.option.series[0].name = mapTitle[this.queryParams.type]
          this.option.series[0].data = numArr
          this.option.series[1].data = userArr
          this.chart.setOption(this.option, true)
          this.queryParams.startDate = res.data.req.startDate
          this.queryParams.endDate = res.data.req.endDate
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportData() {
      this.queryParams.lang = '1'
      this.getTables()
    },
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        color: ['#91c7ae', 'red'],
        title: {
          text: ''
        },
        xAxis: {
          name: '类型',
          type: 'category',
          data: []
        },
        legend: {
          data: ['产出', '人数'],
          bottom: 0
        },
        grid: {
          left: '3%',
          right: '4%',
          containLabel: true
        },
        yAxis: [
          {
            type: 'value',
            name: '总计'
          },
          {
            type: 'value',
            name: '人数'
          }
        ],
        toolbox: {
          show: true
        },
        tooltip: {
          trigger: 'axis'
        },
        series: [
          {
            name: '产出数',
            type: 'bar',
            data: [],
            barWidth: '20%'
          },
          {
            name: '人数',
            type: 'line',
            data: [],
            yAxisIndex: 1,
            barWidth: '50%'
          }
        ]
      }
      this.chart.setOption(this.option)
    },
    numFormatter(col, row, val) {
      return scientificFormat(val)
    }
  }

}
</script>

<style scoped>

</style>
